import styles from "@/styles/collection.module.scss";
import React, { Fragment } from "react";
import Slider from "react-slick";
import SwiperCore, { Navigation, Pagination } from "swiper";
import features7 from "../../../public/img/features-7.png";
import features8 from "../../../public/img/features-8.png";
import features9 from "../../../public/img/features-9.png";
import Image from "next/image";
import Link from "next/link";
import { homeLinks } from "@/data/home";

SwiperCore.use([Navigation, Pagination]);

const Collection = () => {
  const settings = {
    dots: false,
    infinite: true,
     navigation:true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "0px",
        },
      },
    ],
  };

  return (
    <Fragment>
      <section className={styles.collection}>
        <div className="container-fluid">
          <div className={styles.collectionheader}>
            <h2>{homeLinks.collection.title}</h2>
          </div>
          <fw-storyblock
            channel="senco"
            playlist="5zrla5"
            autoplay="true"
            branding="false"
          ></fw-storyblock>
          <div className={styles.collection_slide_main_container}>
            <div className={styles.collectionheader}>
              <div className={styles.h2}>Explore our Collections</div>
            </div>
            <div className="center-slider">
              <Slider {...settings}>
                {homeLinks.collection.sliders.map((v: any, i) => (
                  <Link href={v.link} key={i} passHref>
                    <div className={styles.collection_slide_item}>
                      <div className={styles.slide_img}>
                        <Image
                          src={v.image}
                          className="img-fluid"
                          alt={v.alt}
                          width={460}
                          height={608}
                        />
                      </div>

                      <div className={styles.port_text}>
                        <div className={styles.h3_sub}>{v.name}</div>
                        {/* <p>Collection</p> */}
                        <div className={styles.port_btn}>
                          <i className="bi bi-arrow-right"></i>
                        </div>
                      </div>

                      {/* <div className={styles.port_btn}>
                        <div className="btn-more ">
                          Explore <i className="bi bi-chevron-right"></i>
                        </div>
                      </div> */}
                    </div>
                  </Link>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Collection;
